function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/*
  Determines whether the sanitized value should be compacted and whether it's
  long enough to actually make a difference. For number and dollar format this
  would be a pre-formatted value of +/- 1000. For percent this would be a
  pre-formatted value of +/- 10.

  We use this check to determine whether we should actually pass compact props
  through to the Intl.NumberFormat constructor. If we pass compact props
  through, but the formatted value would never be actually be compacted (because
  it's too small), Intl.NumberFormat won't allow us to use trailing zeros when
  combined with its fractional digit props.
*/
import { COMPACT_OPTIONS, FORMATS } from "../constants.js";
var checkForCompactibility = (sanitizedValue, compact, format) => {
  if (compact && format !== FORMATS.PERCENT && (sanitizedValue >= 999.5 || sanitizedValue <= -999.5) || compact && format === FORMATS.PERCENT && (sanitizedValue >= 9.5 || sanitizedValue <= -9.5)) try {
    /*
      Safari 14.1.x has an obscure bug with this API, making it incompatible
      with a number of options, including one we use: `compactDisplay`. For the
      small number of users this impacts, we try/catch an instance using our
      compact options. We're only doing this in this helper to reduce the number
      of times it needs to be run, and because we want the rest of
      `formatNumber`'s code to run as a "fallback". For more context, see
      https://github.com/google/site-kit-wp/issues/3255
    */
    new Intl.NumberFormat('en-us', _objectSpread({}, COMPACT_OPTIONS)).format(sanitizedValue);
    return true;
  } catch (_unused) {
    return false;
  }
  return false;
};
export default checkForCompactibility;